import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { userService } from '../../_services/user.service'
import FacebookLoginModal from '../login/FacebookLogin'
import Avatar from './Avatar'
import HelpModal from './HelpModal'
import { avatarFor } from '../helpers/source-icons'
import { APP_NAME } from '../../brand'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null,
      menuOpen: false,
      mobileNavOpen: false,
      loginModal: false,
      showHelp: false
    }

    this.toggleMenu = this.toggleMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
    this.logout = this.logout.bind(this)
    this.openLogin = this.openLogin.bind(this)
    this.closeLogin = this.closeLogin.bind(this)
  }

  componentDidMount() {
    this.subscription = userService.currentUser.subscribe(x => {
      this.setState({ user: x })
    })
    document.addEventListener('click', this.closeMenu)

    // PrivateRoute lands here with ?login=true when an anonymous user hits a
    // protected page — open the login modal right away
    if (
      window.location.search.indexOf('login=true') !== -1 &&
      !userService.currentUserValue
    ) {
      this.setState({ loginModal: true })
      window.history.replaceState({}, '', window.location.pathname)
    }
  }

  componentWillUnmount() {
    if (this.subscription) this.subscription.unsubscribe()
    document.removeEventListener('click', this.closeMenu)
  }

  toggleMenu() {
    this.setState(prev => ({ menuOpen: !prev.menuOpen }))
  }

  // React 16 delegates synthetic events on document, so stopPropagation()
  // cannot shield the chip from this native document listener — exclude
  // clicks inside the chip explicitly instead
  closeMenu(e) {
    if (e && this.chipRef && this.chipRef.contains(e.target)) return
    if (this.state.menuOpen) this.setState({ menuOpen: false })
  }

  logout() {
    userService.logout()
  }

  openLogin(e) {
    if (e) e.preventDefault()
    this.setState({ loginModal: true })
  }

  closeLogin() {
    this.setState({ loginModal: false })
  }

  render() {
    const { user, menuOpen, mobileNavOpen, loginModal, showHelp } = this.state

    const avatar = avatarFor(user, 'showly')
    const closeMobileNav = () => this.setState({ mobileNavOpen: false })

    return (
      <nav className="ng-navbar">
        {loginModal ? (
          <FacebookLoginModal handleModalCloseClick={this.closeLogin} />
        ) : null}
        {showHelp ? (
          <HelpModal onClose={() => this.setState({ showHelp: false })} />
        ) : null}

        <div className="ng-navbar-inner">
          <button
            className="ng-hamburger"
            onClick={() => this.setState(prev => ({ mobileNavOpen: !prev.mobileNavOpen }))}
            aria-label="Menu"
          >
            <span className={mobileNavOpen ? 'fa fa-times' : 'fa fa-bars'}></span>
          </button>

          <Link to="/" className="ng-logo ng-wordmark">
            <span className="ng-wordmark-key">⌂</span>
            <span>{APP_NAME}</span>
          </Link>

          <ul className="ng-nav-links">
            <li>
              <Link to="/showings/post">Post a showing</Link>
            </li>
            <li>
              <Link to="/jobs">Find showings</Link>
            </li>
            {user ? (
              <li>
                <Link to="/showings/requests">Dashboard</Link>
              </li>
            ) : (
              <li>
                <a href="/#how-it-works">How it works</a>
              </li>
            )}
          </ul>

          <div style={{ flex: 1 }} />

          {user ? (
            <div className="ng-user-chip" ref={el => (this.chipRef = el)}>
              <button className="ng-user-chip-btn" onClick={this.toggleMenu}>
                <Avatar src={avatar} alt="avatar" />
                <span className="ng-user-name">{user.name}</span>
                <span className="fa fa-angle-down"></span>
              </button>
              {menuOpen ? (
                <div className="ng-user-menu">
                  <Link to="/users/profile/" onClick={() => this.setState({ menuOpen: false })}>
                    <span className="icon-user"></span> My profile
                  </Link>
                  <Link to="/showings" onClick={() => this.setState({ menuOpen: false })}>
                    <span className="fa fa-calendar-check"></span> My showings
                  </Link>
                  <button onClick={() => this.setState({ menuOpen: false, showHelp: true })}>
                    <span className="fa fa-headset"></span> Get help
                  </button>
                  {user.role === 'admin' ? (
                    <Link to="/admin" onClick={() => this.setState({ menuOpen: false })}>
                      <span className="fa fa-shield-alt"></span> Admin console
                    </Link>
                  ) : null}
                  <button onClick={this.logout}>
                    <span className="icon-logout"></span> Sign out
                  </button>
                </div>
              ) : null}
            </div>
          ) : (
            <button className="ng-btn ng-btn-primary" onClick={this.openLogin}>
              Sign in
            </button>
          )}
        </div>

        {mobileNavOpen ? (
          <div className="ng-mobile-nav">
            <Link to="/" onClick={closeMobileNav}>
              <span className="fa fa-home"></span> Home
            </Link>
            <Link to="/showings/post" onClick={closeMobileNav}>
              <span className="fa fa-plus-circle"></span> Post a showing
            </Link>
            <Link to="/jobs" onClick={closeMobileNav}>
              <span className="fa fa-search-dollar"></span> Find showings
            </Link>
            {user ? (
              <>
                <Link to="/showings" onClick={closeMobileNav}>
                  <span className="fa fa-calendar-check"></span> My showings
                </Link>
                <Link to="/users/profile/" onClick={closeMobileNav}>
                  <span className="icon-user"></span> My profile
                </Link>
              </>
            ) : null}
          </div>
        ) : null}
      </nav>
    )
  }
}

export default withRouter(Header)
